import { ref, computed, onMounted, onUnmounted } from 'vue'

export function useTimer(endTime) {
  const currentTime = ref(new Date())
  const intervalId = ref(null)

  const timeRemaining = computed(() => {
    if (!endTime.value) return null

    const end = new Date(endTime.value)
    const now = currentTime.value
    const diff = end.getTime() - now.getTime()

    if (diff <= 0) {
      return { expired: true, display: 'Expired' }
    }

    const hours = Math.floor(diff / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    let display = ''
    if (hours > 0) {
      display = `${hours}h ${minutes}m`
    } else if (minutes > 0) {
      display = `${minutes}m ${seconds}s`
    } else {
      display = `${seconds}s`
    }

    return {
      expired: false,
      display,
      hours,
      minutes,
      seconds,
      totalSeconds: Math.floor(diff / 1000)
    }
  })

  const isExploring = computed(() => {
    const remaining = timeRemaining.value
    return remaining && !remaining.expired
  })

  function startTimer() {
    if (intervalId.value) return

    intervalId.value = setInterval(() => {
      currentTime.value = new Date()
    }, 1000)
  }

  function stopTimer() {
    if (intervalId.value) {
      clearInterval(intervalId.value)
      intervalId.value = null
    }
  }

  onMounted(() => {
    if (endTime.value) {
      startTimer()
    }
  })

  onUnmounted(() => {
    stopTimer()
  })

  return {
    timeRemaining,
    isExploring,
    startTimer,
    stopTimer
  }
}
